import React from "react";
import PropTypes from "prop-types";
import {Checkbox, FormGroup} from "react-bootstrap";
import CheckpointIntegrationSelector from "./CheckpointIntegrationSelector";
import IntegrationPolygonForm from "./IntegrationPolygonForm";
import "./CheckpointIntegration.css";
import Objects from "../../utils/Objects";

class CheckpointIntegrationForm extends React.Component {

  constructor(props) {
    super(props);
    const defaultValue = props.defaultValue || {};
    this.isIntegrated = defaultValue.isIntegrated;
    this.state = {entity: defaultValue, setValue: props.setValue, isIntegrated: this.isIntegrated};
  }

  onChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.isIntegrated = value;
    this.setState({isIntegrated: value});
    this.setNewValues();
  }

  readpointSelected(value) {
    this.readpointId = value;
    this.setNewValues();
  }

  setNewValues() {
    const {setValue} = this.state;
    const params = {};

    if (!Objects.isEmptyOrBlank(this.readpointId)) {
      params['READPOINT_ID'] = this.readpointId;
    }

    const value = {isIntegrated: this.isIntegrated, integrationType: this.integrationType, params};
    setValue && setValue(value)
  }

  changeIntegrationType(value) {
    const {entity = {}} = this.state;
    this.integrationType = value;
    let component = null;
    if (value === 'POLYGON_INTEGRATION') {
      component = <IntegrationPolygonForm defaultValue={entity.integrationParams} setValue={value => this.readpointSelected(value)}/>;
    }

    this.setState({integrationComponent: component});
    this.setNewValues();
  }

  typeSelect() {
    const {entity = {}, isIntegrated = ''} = this.state;
    return (
        <FormGroup>
          <CheckpointIntegrationSelector
              required={isIntegrated === 'checked'}
              defaultValue={entity && entity.integrationType}
              setValue={value => this.changeIntegrationType(value)}/>
        </FormGroup>
    );
  }

  render() {
    const {isIntegrated = '', integrationComponent = null} = this.state;
    const selectType = isIntegrated ? this.typeSelect() : '';
    return (
        <div className="integration-box">
          <FormGroup>
            <Checkbox title="Integração" onChange={(event) => this.onChange(event)}
                      inline={true} checked={isIntegrated}>
              Integração
            </Checkbox>

          </FormGroup>

          {selectType}

          {integrationComponent}
        </div>
    );
  }

}

CheckpointIntegrationForm.propTypes = {
  defaultValue: PropTypes.object,
  setValue: PropTypes.func
};

export default CheckpointIntegrationForm;



// WEBPACK FOOTER //
// ./src/checkpoint/integration/CheckpointIntegrationForm.js